import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { painCosts } from '../data/includes';
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-168" data-mp="2lp556r9nb2to">
      <div className="max-w-3xl mx-auto" data-id="element-169" data-mp="26z7kwmeu6x9r">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-170" data-mp="26wbqh8276qq2">
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-171" data-mp="1o1el3szif3gl">
            A Workday That Feels Too Familiar
          </p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-charcoal" data-id="element-172" data-mp="3idbgfx12otgx">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-charcoal-soft leading-relaxed bg-paper p-6 rounded-2xl border border-warmgray text-left space-y-4" data-id="element-173" data-mp="3nbwh1xk8lf5w">
            <p data-id="element-174" data-mp="1u1ty4s2rmggc">
              Your next client is arriving soon. And you're still thinking about
              what you're going to do.
            </p>
            <p data-id="element-175" data-mp="27sh0qvbncqhp">
              Which region should you prioritize? Which techniques should you
              use? How much time should you spend on each area? Should you
              change the pressure? Should the client be prone, supine,
              side-lying, or seated? And what happens when this client needs
              something completely different from the last one?
            </p>
            <p data-id="element-176" data-mp="1p427009y2yd7">
              <span className="text-terracotta font-medium" data-id="element-177" data-mp="1p0ecoywoe7xf">
                Not because you don't know massage.
              </span>{' '}
              You already know massage. The problem is that learning individual
              techniques is not the same as having a complete professional
              system for turning those techniques into structured, adaptable
              sessions.
            </p>
            <p data-id="element-178" data-mp="1t7hp6bve4q4s">
              So you keep building appointments from scratch. And over time,
              that costs you more than preparation time.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="space-y-6" data-id="element-179" data-mp="2240jnsj9sm3h">
          <h3 className="text-xl font-bold text-charcoal mb-8 text-center" data-id="element-180" data-mp="1je0tf2bp10yh">
            The Real Cost of Not Having the Right System
          </h3>

          <ul className="space-y-3" data-id="element-181" data-mp="qr7p69z3hjjq">
            {painCosts.map((point, i) => <motion.li key={point} initial={{
            opacity: 0,
            x: -16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: Math.min(i, 5) * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-4 bg-sand p-4 rounded-xl border border-warmgray" data-id="element-182" data-mp="vphngtg4909k" data-mpi={i}>
                <X size={18} className="text-terracotta-dark shrink-0 mt-0.5" aria-hidden="true" data-id="element-183" data-mp="ge5wvy8k16l" />
                <span className="text-charcoal-soft" data-id="element-184" data-mp="3mnvriu4ef0v4">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-warmgray" data-id="element-185" data-mp="3imk1inhm4dme">
            <p className="text-2xl font-serif font-bold text-terracotta-deep" data-id="element-186" data-mp="3dn7iyexrxspm">
              Stop giving away your preparation time. Your professional
              knowledge is already there. What you need now is the right system
              behind it.
            </p>
            <p className="text-xl mt-4 text-charcoal" data-id="element-187" data-mp="1lnqxjdjndzyq">
              Start your next working week with every session already
              structured.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}